import { currentActivitySpan, encodeSpanHeader } from "@/lib/activity-span";

import {
  __GLOBAL_ASSESSMENT_ID,
  __GLOBAL_TENANT,
  __GLOBAL_WORK_ID,
} from "./globals";

/**
 * Common HTTP request headers from global context for all Aphrodite requests.
 */
export function globalHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};

  headers["x-cadmus-role"] = "student";
  headers["x-cadmus-tenant"] = __GLOBAL_TENANT.current ?? "";
  headers["x-cadmus-assessment"] = __GLOBAL_ASSESSMENT_ID.current ?? "";

  if (__GLOBAL_WORK_ID.current) {
    headers["x-cadmus-work"] = __GLOBAL_WORK_ID.current;
  }

  const activitySpan = currentActivitySpan();
  if (activitySpan) {
    headers["x-cadmus-span"] = encodeSpanHeader(activitySpan);
  }

  return headers;
}
